import { useLocation, useNavigate } from 'react-router-dom';
import {
  Card, CardContent, makeStyles, Typography,
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  card: {
    background: theme.palette.background.card,
    borderRadius: 10,
    margin: theme.spacing(0, 0, 2, 0),
    cursor: 'pointer',
    '&:hover': {
      background: theme.palette.background.hoverCard,
    },
  },
  cardDisabled: {
    background: '#ff99991f',
    borderRadius: 10,
    margin: theme.spacing(0, 0, 2, 0),
  },
  cardEvaluationText: {
    color: theme.palette.text.default,
    fontFamily: 'Raleway',
    padding: theme.spacing(1, 0),
  },
  cardEvaluationTextDisabled: {
    color: '#7e7777',
    fontFamily: 'Raleway',
    padding: theme.spacing(1, 0),
  },
  link: {
    textDecoration: 'none',
  },
}));
function EvaluationCard() {
  const classes = useStyles();
  const location = useLocation();
  const navigate = useNavigate();

  const handleNavigateToEvaluation = () => navigate('/quizz', {
    state: {
      ...location.state,
    },
  });
  return (
    <Card
      className={location.state.quizzStatus ? classes.card : classes.cardDisabled}
      onClick={location.state.quizzStatus ? handleNavigateToEvaluation : null}
    >
      <CardContent>
        <Typography
          className={
            location.state.quizzStatus
              ? classes.cardEvaluationText : classes.cardEvaluationTextDisabled
          }
        >
          Evaluación
        </Typography>
      </CardContent>
    </Card>
  );
}

export default EvaluationCard;
